import React from "react";
import { Box } from "@chakra-ui/react";
import Slideshow from "../components/Homepage/Slideshow";
import InfoSection from "../components/Homepage/InfoSection";

const Homepage = () => {
  return (
    <Box 
      width="100%" 
      overflowX="hidden"
      position="relative"
    >
      <Slideshow />
      <InfoSection />
    </Box>
  );
};

export default Homepage;
